import { ALL_FILTER_VALUE } from '@features/regional-overview/regional-overview.models';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const isAllOrEmpty = (value: unknown): boolean => {
  if (value === undefined) return true;
  if (value === ALL_FILTER_VALUE) return true;
  if (!Array.isArray(value)) return false;
  if (value.length === 0) return true;
  return value[0] === ALL_FILTER_VALUE;
};

export const computeCalculatedRisk = (diseases: ReadonlyArray<{ risk: number }>, hasError = false): number => {
  if (hasError) return RiskLevelEnum.MISSING_CONFIG;
  const activeRisks = diseases.map(disease => disease.risk).filter(risk => risk !== RiskLevelEnum.NO_RISK);
  if (activeRisks.length === 0) return RiskLevelEnum.NO_RISK;
  return Math.max(...activeRisks);
};
